// redux/actions/TIPO_AUTORIDADES/types.js
export const FETCH_TIPO_AUTORIDADES_SUCCESS = "FETCH_TIPO_AUTORIDADES_SUCCESS";
export const FETCH_TIPO_AUTORIDADES_FAILURE = "FETCH_TIPO_AUTORIDADES_FAILURE";
